import AddDocumentModal from './main.add-document'

export default AddDocumentModal